// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Pzkf","field":"styles_field__hYmZX","fieldCol":"styles_fieldCol__2KFWy","diffCol":"styles_diffCol__2qcTJ","diff":"styles_diff__3wVbI"};